import {
  Column,
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  GridComponent,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  ToolbarItems,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Group,
  Resize,
  ForeignKey,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import 'react-toastify/dist/ReactToastify.css';
import 'react-jquery-plugin';
import { all_information, loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import {
  createTeam,
  getTeams,
  teamDelete,
  teamUpdate,
} from '../../services/tradeperson/team';
import { upperCase } from 'lodash';
import {
  loadOrganizationOptions,
  OrgOption,
} from '../../utils/organizationOptions';

interface IProps {}
interface IState {
  TeamsData: any;
  hideDialog: boolean;
  inputName: any;
  inputDescription: any;
  pickedTeamId: any;
  hideDialogDelete: boolean;
  hideEditDialog: boolean;
  organizations: OrgOption[];
  orgsLoaded: boolean;
  inputOrganizationId: string | null;
}
export default class Teams extends React.Component<IProps, IState> {
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  private ElementType: any = ['Shift', 'Exception'];
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private buttons: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsEdit: ButtonPropsModel[];
  private grid: any;
  private animationSettings: AnimationSettingsModel;
  private time: Date = new Date('8/3/2017 10:00');
  constructor(props: IProps) {
    super(props);

    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTeam();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsEdit = [
      {
        click: () => {
          this.editTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideEditDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.createTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      hideEditDialog: false,
      hideDialogDelete: false,
      pickedTeamId: '',
      inputName: '',
      inputDescription: '',
      TeamsData: [],
      hideDialog: false,
      organizations: [],
      orgsLoaded: false,
      inputOrganizationId: null,
      // @ts-ignore
      update: false,
    };
  }
  private dialogClose(): void {
    this.setState({
      hideDialog: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }
  componentDidUpdate(prevProps: any, prevState: any) {
    // @ts-ignore
    if (this.state.update) {
      getTeams().then((result) => {
        this.setState({ TeamsData: result.data });
        // @ts-ignore
        this.setState({ update: true });
      });
    }
  }
  componentDidMount() {
    loadOrganizationOptions()
      .then((orgs) => this.setState({ organizations: orgs, orgsLoaded: true }))
      .catch(() => this.setState({ orgsLoaded: true }));
    this.getTheTeams();
  }
  getTheTeams() {
    getTeams().then((result) => {
      this.setState({ TeamsData: result.data });
    });
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({
        inputName: '',
        inputDescription: '',
        inputOrganizationId: all_information.company_id
          ? String(all_information.company_id)
          : null,
        hideDialog: true,
      });
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const rec = this.grid.getSelectedRecords()[0];

        this.setState({
          inputName: rec.team_code,
          inputDescription: rec.description,
          inputOrganizationId: rec.organization_id != null ? String(rec.organization_id) : null,
        });

        this.dialogOpenEdit();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.dialogOpenDelete();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
  }
  private dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }

  private dialogOpenEdit(): void {
    this.setState({ hideEditDialog: true });
  }
  private dialogCloseEdit(): void {
    this.setState({
      hideEditDialog: false,
    });
  }
  filterTeamDesc(t_code: any) {
    if (this.state.TeamsData.length > 1) {
      let teamId = this.state.TeamsData.filter((item: any) => {
        return item.teamCode === t_code;
      });
      return teamId[0].description;
    } else {
      return '';
    }
  }

  editTeam() {
    var theElements = this.grid.getSelectedRecords();
    if (theElements.length === 0) {
      Message.error('No record is selected to procced');
      return;
    }
    var teamCode = this.state.inputName;
    var description = this.state.inputDescription;
    if (teamCode === '') {
      Message.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (description === '') {
      Message.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }
  
    if (!this.state.inputOrganizationId) {
      Message.error('Organization cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      team_code: teamCode,
      description: description,
      team_id: theElements[0].team_id,
      organization_id: this.state.inputOrganizationId,
    };
    teamUpdate(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Edited successfully...');
        this.dialogClose();
        this.getTheTeams();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Editing failed!!!');
      });

    this.dialogCloseEdit();
  }
  deleteTeam() {
    var theElements = this.grid.getSelectedRecords();
    if (theElements.length === 0) {
      Message.error('No record is selected to procced');
      return;
    }
    teamDelete([theElements[0].team_id])
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.dialogClose();
        this.getTheTeams();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.dialogCloseDelete();
  }
  async createTeam() {
    var teamCode = this.state.inputName;
    var description = this.state.inputDescription;
    if (teamCode === '') {
      Message.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (description === '') {
      Message.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }
  
    if (!this.state.inputOrganizationId) {
      Message.error('Organization cannot be empty');
      loadingShow(false);
      return false;
    }
    const res = await getTeams();
    let teams: { team_code: string; description: string }[] = res.data;
    loadingShow(true);
    const teamExists = teams.some(
      (eachteam) => upperCase(eachteam.team_code) === upperCase(teamCode)
    );

    if (teamExists) {
      Message.error('Same Team Already Exist');
      loadingShow(false);
      return false;
    }

    let obj = {
      team_code: teamCode,
      description: description,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: this.state.inputOrganizationId,
      creation_date: new Date(),
    };
    createTeam(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Added successfully...');
        this.getTheTeams();
        this.dialogClose();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Add failed!!!');
      });
    loadingShow(false);
  }

  private renderOrganizationRow() {
    return (
      <div className='row mb-3'>
        <div className='col-md-3'>Organization:</div>
        <div className='col-md-9'>
          <DropDownListComponent
            dataSource={this.state.organizations as any}
            fields={{ text: 'name', value: 'id' }}
            value={this.state.inputOrganizationId as any}
            placeholder='Select Organization'
            popupHeight='250px'
            allowFiltering={true}
            change={(e: any) =>
              this.setState({ inputOrganizationId: e.value })
            }
          />
        </div>
      </div>
    );
  }

  onGridActionComplete(args: any) {
  if (args.requestType === 'save' && args.action === 'edit') {
    const d = args.data;

    if (!d.team_code || !d.description || !d.organization_id) {
      Message.error('Team Name, Description and Organization cannot be empty');
      this.getTheTeams();
      return;
    }

    teamUpdate({
      team_id: d.team_id,
      team_code: d.team_code,
      description: d.description,
      organization_id: String(d.organization_id),
    })
      .then(() => {
        Message.success('Edited successfully...');
        this.getTheTeams();
      })
      .catch(() => {
        Message.error('Editing failed!!!');
        this.getTheTeams();
      });
  }
}

  render() {
    return (
      <div>
      {this.state.orgsLoaded && (
        <GridComponent
          dataSource={this.state.TeamsData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.grid = g)}
          height='calc(-270px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          toolbarClick={this.toolbarClick.bind(this)}
          actionComplete={this.onGridActionComplete.bind(this)}
          gridLines={'Both'}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='team_code'
              headerText='Team Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='description'
              headerText='Team Description'
              textAlign='Left'
            />
              <ColumnDirective
                field='organization_id'
                headerText='Organization'
                textAlign='Left'
                foreignKeyField='id'
                foreignKeyValue='name'
                dataSource={this.state.organizations as any}
            />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group, ForeignKey]}
          />
        </GridComponent>
        )}

        {this.state.hideEditDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogAddTeam'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideEditDialog}
            width={'400px'}
            header='Team Editing'
            buttons={this.buttonsEdit}
            open={this.dialogOpenEdit.bind(this)}
            close={this.dialogCloseEdit.bind(this)}
          >
            <div className='row mb-3'>
              <div className='col-md-3'>Team Name:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  input={(e) => {
                    this.setState({ inputName: e.value });
                  }}
                  value={this.state.inputName}
                  placeholder='Enter Name'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Description:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  input={(e) => {
                    this.setState({ inputDescription: e.value });
                  }}
                  value={this.state.inputDescription}
                  placeholder='Enter Description'
                />
              </div>
            </div>
            {this.renderOrganizationRow()}
          </DialogComponent>
        ) : null}
        {this.state.hideDialogDelete ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideDialogDelete}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={this.dialogOpenDelete.bind(this)}
            close={this.dialogCloseDelete.bind(this)}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
        <div className='control-pane-dialogAdd'>
          <div
            id='targetElementAddTeam'
            className='col-lg-12 defaultDialogAddTeam dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogAddTeam'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                width={'400px'}
                header='Team'
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
              >
                <div className='row mb-3'>
                  <div className='col-md-3'>Team Name:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ inputName: e.value });
                      }}
                      value={this.state.inputName}
                      placeholder='Enter Name'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Description:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      input={(e) => {
                        this.setState({ inputDescription: e.value });
                      }}
                      value={this.state.inputDescription}
                      placeholder='Enter Description'
                    />
                  </div>
                </div>
                {this.renderOrganizationRow()}
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
